import type { FourPillars } from '../types/pillars';
import type { NapeumCompat } from '../types/compatibility';
import { getNapeumOhaeng, getNapeumName } from '../sinsal/definitions';
import { getElementRelationship } from '../core/five-elements';

const RELATION_LABEL: Record<string, string> = {
  same: '비화 (보통)',
  generates: '상생 (좋음)',
  generated: '피생 (좋음)',
  overcomes: '상극 (주의)',
  overcome: '피극 (주의)',
};

/**
 * 두 사주의 년주 납음오행 궁합을 분석한다.
 */
export function analyzeNapeumCompat(fp1: FourPillars, fp2: FourPillars): NapeumCompat {
  const idx1 = fp1.year.sexagenaryIndex;
  const idx2 = fp2.year.sexagenaryIndex;

  const ohaeng1 = getNapeumOhaeng(idx1);
  const ohaeng2 = getNapeumOhaeng(idx2);
  const name1 = getNapeumName(idx1);
  const name2 = getNapeumName(idx2);

  const relation = getElementRelationship(ohaeng1, ohaeng2);

  const description = `납음궁합: ${name1}(${ohaeng1}) ↔ ${name2}(${ohaeng2}) — ${RELATION_LABEL[relation]}`;

  return {
    person1Napeum: { ohaeng: ohaeng1, name: name1 },
    person2Napeum: { ohaeng: ohaeng2, name: name2 },
    relation,
    description,
  };
}
